import { useEffect, useState } from 'react';
import { downloadZip } from 'client-zip';
import HashLoader from 'react-spinners/HashLoader';
import ClipLoader from 'react-spinners/ClipLoader';
import axios from 'axios';
import { getFileName, getModelName } from '../Services/ValueTransform';

const PreviewModal = ({ fan, handleClose, modelTypeSelect }) => {
  const [loading, setLoading] = useState(0);
  const [preview, setPreview] = useState(null);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (fan) {
      getPreview();
      document.body.style = 'overflow: hidden';
    }
  }, [fan]);

  const getPreview = async () => {
    setLoading(true);
    const response = await axios.get(`/api/v1/preview-pdf/${fan.id}`, {
      params: fan.configs,
    });
    if (response?.data?.success === true) {
      setPreview(response.data.payload.preview);
    }
    setLoading(false);
  };

  const startJob = async () => {
    if (exporting === true) return;
    setExporting(true);
    const zipBuffer = [];
    const { data } = await doExport();
    if (data) {
      const name = getFileName(fan);
      zipBuffer.push({
        name: `${name}.pdf`,
        lastModified: new Date(),
        input: data,
      });
    }
    const zipBlob = await downloadZip(zipBuffer).blob();
    const link = document.createElement('a');
    const downloadUrl = URL.createObjectURL(zipBlob);
    link.href = downloadUrl;
    link.download = 'DyuniAir_Export.zip';
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadUrl);
    setExporting(false);
  };
  const doExport = async () => {
    return await axios.get(`/api/v1/generate-pdf/${fan.id}`, {
      responseType: 'blob',
      params: fan.configs,
    });
  };

  const onClose = (e) => {
    document.body.style = '';
    setPreview(null);
    setExporting(false);
    handleClose(e);
  };

  if (fan === false) return null;
  return (
    <div
      class='relative z-10'
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
      style={{ zIndex: 99 }}
    >
      <div
        class='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'
        style={{ backgroundColor: '#6f6f6fbf' }}
      ></div>

      <div
        class='fixed inset-0 z-10 w-screen overflow-y-auto'
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: 20,
        }}
      >
        <div
          style={{
            maxWidth: 800,
            minWidth: 800,
            background: 'white',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            height: 'fit-content',
            minHeight: '100%',
          }}
        >
          <div
            class='bg-gray-50 sm:flex sm:flex-row bg-custom'
            style={{
              justifyContent: 'flex-end',
              height: 40,
              width: '100%',
              paddingTop: 10,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                color: 'white',
                fontWeight: 'bold',
              }}
            >
              <span>
                Preview {fan ? getModelName(fan, modelTypeSelect) : ''}
              </span>
            </div>
            <button
              type='button'
              class='btn-custom'
              onClick={startJob}
              style={{ padding: '5px 10px', border: 'solid 1px #fff' }}
            >
              {exporting === true ? (
                <ClipLoader
                  color={'#36d7b7'}
                  size={20}
                  aria-label='Loading Spinner'
                  data-testid='loader'
                />
              ) : (
                'Export'
              )}
            </button>
            <button
              type='button'
              class='btn-custom '
              onClick={onClose}
              style={{ padding: '5px 10px', marginLeft: 50, marginRight: 20 }}
            >
              Close
            </button>
          </div>
          <div
            class='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'
            style={{ display: 'flex', width: '100%' }}
          >
            {!loading && preview && <img src={preview} />}
            {loading && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 150,
                }}
              >
                <HashLoader
                  color={'#36d7b7'}
                  // loading={loading}
                  // cssOverride={override}
                  size={50}
                  aria-label='Searching'
                  data-testid='loader'
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
